import { RootState } from 'store/types';
import { createSelector } from 'reselect';
import { auditServiceSelector } from 'store/appSettings/selectors';

export const auditSelector = (state: RootState) => state.audit;

export const auditFetchingSelector = createSelector(auditSelector, audit => audit.isFetching);

export const auditErrorSelector = createSelector(auditSelector, audit => audit.error);

export const auditRowCountSelector = createSelector(auditSelector, audit => audit.totalRowCount);

export const auditPageNumberSelector = createSelector(
  auditSelector,
  audit => audit.currentPageNumber
);

export const auditTotalPageNumberSelector = createSelector(
  auditSelector,
  audit => audit.totalPages
);

export const auditPagesSelector = createSelector(auditSelector, audit => audit.pages);

export const auditByPageSelector = createSelector(
  [auditSelector, auditPageNumberSelector],
  (audit, currentPage) => audit.pages[currentPage]
);

export const auditCategoriesDataSelector = createSelector(
  auditServiceSelector,
  auditService => auditService.categories || []
);

export const auditActionsDataSelector = createSelector(
  auditServiceSelector,
  auditService => auditService.actions || []
);

export const auditLogFilterOptionsSelector = createSelector(
  auditSelector,
  audit => audit.filterOptions
);
export const auditLogFiltersDownloadStatus = createSelector(
  auditSelector,
  audit => audit.auditLogFiltersDownloadStatus
);
